import React, { FC, ReactNode, useEffect, useState } from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import { GroupBase, OptionsOrGroups } from 'react-select';
import { apiDropdownService } from '../../../../shared/services/dropdown-service';
import { Dropdown } from '../../../../shared/models/common.model';
import { InputActionMeta } from 'react-select/dist/declarations/src/types';

interface ProvinceSelectProps {
    value: any,
    disable: boolean,
    onChange: (data: Dropdown) => void;
}

const ProvinceSelect: FC<ProvinceSelectProps> = ({value, disable, onChange}) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [localValue, setLocalValue] = useState({value: value, label: ""});

  const getProvinceName = async () => {
    setIsLoading(true);
    try {
      let options = await apiDropdownService.getProvinceDropdown({province_id: value , province_name: null});
      if (options) {
        setLocalValue({
          label: options[0]?.label as any,
          value: value
        });

      }
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching options:', error);
      setIsLoading(false);
    }
  };

    useEffect(() => {
        if (value) {
          getProvinceName();
        }
    }, [value]);

    type OptionType = {
        value: number;
        label: string;
    };

    const getParams = (search: string , province_id: number | null) => {
        return {
            province_name: search,
            province_id: province_id
        };
    };

    const loadOptions = async (
        search: string,
        prevOptions: OptionsOrGroups<OptionType, GroupBase<OptionType>>
    ) => {
        let options = [];
        if (!search && !!localValue.value) {
            search = localValue.value;
        }

        if (search) {
            setIsLoading(true);
            try {
                options = await apiDropdownService.getProvinceDropdown(getParams(search, null));
                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching options:', error);
                setIsLoading(false);
            }
        }
        return {
            options: options,
        };
    };

    const handleOnChange = (newValue: any) => {
        onChange(newValue);
        setLocalValue({
            label: newValue.label,
            value: null,
        });
    };

    const MyOption = (props: any) => {
        const {innerProps, innerRef} = props;

        return (
            <div ref={innerRef} {...innerProps}
                 className={`px-1 py-1 pointer primary-select`}>
                <p className="m-0" style={{paddingLeft:"10px"}}>{props?.label}</p>
            </div>
        );
    };

    const onInputChange = (newValue: string, actionMeta: InputActionMeta) => {
        if (actionMeta.action === 'input-change') {
            setLocalValue({
                label: newValue,
                value: newValue,
            });
        }
    };

    const noOptionMessage = (obj: {
        inputValue: string;
    }) => {
        return <>กรุณาพิมพ์จังหวัด เพื่อค้นหา...</>
    }

    return <>
        <AsyncPaginate
            debounceTimeout={300}
            loadOptions={loadOptions}
            isLoading={isLoading}
            onChange={handleOnChange}
            isDisabled={disable}
            value={localValue}
            styles={{
                input: (baseStyles, state) => ({
                    ...baseStyles,
                    input: {
                        opacity: '1 !important',
                        visibility: 'visible'
                    },
                }),
                indicatorsContainer: (baseStyles, state) => ({
                    ...baseStyles,
                    display: 'none'
                })
            }}
            onInputChange={onInputChange}
            noOptionsMessage={noOptionMessage}
            inputValue={localValue.label}
            controlShouldRenderValue={false}
            components={{Option: MyOption}}
            placeholder=""
        />
    </>;
};

export default ProvinceSelect;